import classNames from 'classnames';
import H from 'history';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavMenu.module.scss';

type NavMenuItemProps = {
    icon: JSX.Element;
    title: string;
    pathname: string;
    location: string;
    disabled?: boolean;
    referrerLocation?: H.Location;
    isNavModal?: boolean;
    replace?: boolean;
    collapses?: boolean;
    exact?: boolean;
    onClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
    testId: string;
};

export const NavMenuItem = (props: NavMenuItemProps) => {
    const textClass = classNames(styles.text, {
        [styles.navCollapses]: props.collapses,
        [styles.textDisabled]: props.disabled
    });

    if (props.disabled) {
        const disabledLink = classNames(styles.link, {
            [styles.linkDisabled]: props.disabled
        });
        return (
            <div className={disabledLink}>
                {React.cloneElement(props.icon, { className: styles.icon })}
                <div className={textClass}>{props.title}</div>
            </div>
        );
    }

    const testId = props.testId ? `navlink_${props.testId}` : null;

    return (
        <NavLink
            to={{ pathname: props.location, state: { referrer: props.referrerLocation, modal: props.isNavModal } }}
            exact={props.exact}
            title={props.title}
            replace={props.replace}
            className={styles.link}
            onClick={props.onClick}
            activeClassName={styles.linkActive}
        >
            {React.cloneElement(props.icon, { className: styles.icon })}
            <div className={textClass} data-test-id={testId}>
                {props.title}
            </div>
        </NavLink>
    );
};

export const NavMenu: React.FC<{
    collapses?: boolean;
    isCollapsed?: boolean;
}> = props => {
    const navMenuClass = classNames(styles.links, {
        [styles.collapsed]: props.isCollapsed
    });

    return (
        <div className={navMenuClass}>
            {React.Children.map(props.children, (child: any) => {
                if (child) return React.cloneElement(child, { collapses: props.collapses });

                return null;
            })}
        </div>
    );
};
